export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const API_BASE = 'https://sellyourcar2jack.directaffinitycx.net/api'
export const AUTH_API_KEY='c1c28936-81fc-471a-b104-cb91beb4a6d3'